// src/online/socket.js
import { io } from "socket.io-client";
import { API_URL } from "../config/api";

export const socket = io(API_URL, {
  autoConnect: false,
  withCredentials: true,
  transports: ["websocket"]
});
